import { Navigate } from 'react-router-dom';
import { useAuth } from '../provider/AuthProvider';
import { RouteNames } from './AppRouter';

function AnonymousRoute({ children }) {
    const { token } = useAuth();
    const isAuthenticated = !!token;

    if (isAuthenticated) {
        return <Navigate to={RouteNames.myComics} replace />;
    }

    return children;
}

export default AnonymousRoute;
